<proffeo-ui-dialog [title]="'project-tasks.modals.create-modal-title' | translate">
  <div class="w-full">
    <proffeo-task-create
      [(firstStep)]="firstStep"
      [projectIndustries]="dialogData.projectIndustries()"
      [projectLocations]="dialogData.projectLocations()"
      [createTaskForm]="createTaskForm"
      [project]="dialogData.project()"
      [taskTypes]="dialogData.taskTypes()"
      class="w-full"
    ></proffeo-task-create>
  </div>

  <div
    [class.justify-end]="firstStep()"
    dialog-actions
    class="flex w-full justify-between md:justify-end gap-2"
  >
    @if (firstStep()) {
      <proffeo-ui-button
        text="close"
        matDialogClose
      ></proffeo-ui-button>
    } @else {
      <proffeo-ui-button
        (clicked)="firstStep.set(true)"
        text="labels-project-buttons-back"
      ></proffeo-ui-button>
      <proffeo-ui-button
        (clicked)="save(true)"
        [disabled]="createTaskForm().invalid() || createTaskForm().submitting()"
        variant="accent"
        text="task-create-save-and-new"
      ></proffeo-ui-button>
      <proffeo-ui-button
        (clicked)="save()"
        [disabled]="createTaskForm().invalid() || createTaskForm().submitting()"
        variant="accent"
        text="task-create-save"
      ></proffeo-ui-button>
    }
  </div>
</proffeo-ui-dialog>
